import type { CSSProperties } from 'react'

import { EVNTTZ_ICON_COMPONENTS } from './icons'
import type { EvnttzIconName, EvnttzIconTint } from './types'

export type EvnttzIconProps = {
  name: EvnttzIconName
  size?: number
  className?: string
  style?: CSSProperties
  tint?: EvnttzIconTint
}

export function EvnttzIcon({
  name,
  size = 38,
  className,
  style,
  tint = 'brand'
}: EvnttzIconProps) {
  const Icon = EVNTTZ_ICON_COMPONENTS[name]

  if (!Icon) {
    return (
      <span
        className={className}
        style={{ display: 'inline-block', width: size, height: size, ...style }}
        aria-hidden
      />
    )
  }

  const tintClass = tint === 'event' ? 'evnttz-icon-tint-event' : undefined

  return (
    <span
      className={[tintClass, className].filter(Boolean).join(' ') || undefined}
      style={{
        display: 'inline-flex',
        flexShrink: 0,
        lineHeight: 0,
        ...style
      }}
    >
      <Icon width={size} height={size} aria-hidden focusable={false} />
    </span>
  )
}

EvnttzIcon.displayName = 'EvnttzIcon'
